import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {BusinessFleetService} from 'services/calculator-items/business-fleet.service';

@Component({
  selector: 'tpc-fleet-list',
  templateUrl: './fleet-list.component.html',
  styleUrls: ['./fleet-list.component.css']
})
export class FleetListComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    public vehicleType = 'car';
    public vehicleList = [];

    constructor(private fleetService: BusinessFleetService,
                private footerService: FooterNavbarService,
                private router: Router
    ) {
        this.nextSub = footerService.next$.subscribe(() => this.next());
    }

    ngOnInit() {
        this.vehicleList = this.fleetService.getVehicleList();
    }

    next() {
        this.footerService.skip();
    }

    addVehicle() {
        this.router.navigate(['/business/fleet/' + this.vehicleType]);
    }

    deleteVehicle(index) {
        this.fleetService.deleteFromVehicleList(index);
        this.vehicleList = this.fleetService.getVehicleList();
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/business-calculator/fleet/fleet-list/fleet-list.component.ts